import { $4, $$4, $id4, isRTL, formatMoney, debounce, getterAdd, getterGet, getterRunFn, btnTooltip, DrawerComponent, VariantChangeBase } from "@theme/global";

// WISHLIST
var $wishlist_list = $id4('hdt_wishlist_list'),
  $compare_list = $id4('hdt_compare_list'),
  nameCachedWishlist = 'theme4:wishlist:id',
  nameCachedCompare = 'theme4:compare:id';
// if exit $wishlist_list is use app wishlist the4
if ($wishlist_list) {
  var arr_wishlist_list = $wishlist_list.textContent ? $wishlist_list.textContent.split(' ') : [];
}
else {
  var arr_wishlist_list = (!localStorage.getItem(nameCachedWishlist)) ? [] : localStorage.getItem(nameCachedWishlist).split(',');  // remove id: and conver array
}
if ($compare_list){
  var arr_compare_list = $compare_list.textContent ? $compare_list.textContent.split(' ') : [];
}
else {
  var arr_compare_list = (!localStorage.getItem(nameCachedCompare)) ? [] : localStorage.getItem(nameCachedCompare).split(',');  // remove id: and conver array
}
// arr_wishlist_list = [1234, 5678, 9011]
// arr_compare_list = [1234, 5678, 9011]

var linkWishlistApp = '/apps/ecomrise/wishlist',
  linkCompareApp = '/apps/ecomrise/compare',
  actionAfterWishlistAdded = themeHDN.extras.AddedWishlistRemove ? 'remove' : 'added',
  actionAfterCompareAdded = themeHDN.extras.AddedCompareRemove ? 'remove' : 'added',
  limitWishlist = $wishlist_list ? 100 : 50,
  limitCompare = 5,
  conver_to_link_fn = function (prefix = this.textFn, array = this.array) {
    const x = themeHDN.routes.search_url + `/?view=${prefix}`,
      y = x + '&type=product&options[unavailable_products]=last&q=';
    return (array.length) ? y + encodeURI(`id:${array.join(' OR id:')}`) : x;
  };
// Reset if limit change
if (arr_wishlist_list.length > limitWishlist) {
  arr_wishlist_list.splice(limitWishlist - 1, arr_wishlist_list.length - 1);
  localStorage.setItem(nameCachedWishlist, arr_wishlist_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageWishlist) {
  if (arr_wishlist_list.length && !window.isWishlistPerformed) {
    window.location.href = conver_to_link_fn('wishlist', arr_wishlist_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('wishlist', []));
  }
  themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
}

// Reset if limit change
if (arr_compare_list.length > limitCompare) {
  arr_compare_list.splice(limitCompare - 1, arr_compare_list.length - 1);
  localStorage.setItem(nameCachedCompare, arr_compare_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageCompare) {
  if (arr_compare_list.length && !window.isComparePerformed) {
    window.location.href = conver_to_link_fn('compare', arr_compare_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('compare', []));
  }
}
var _wishlist_id, _wishlist_handle,
  _update_wis_text, update_wis_text_fn,
  _update_wis_btns, update_wis_btns_fn,
  _click_wis, click_wis_fn,
  _add_wis, add_wis_fn,
  _remove_wis, remove_wis_fn,
  _action_after_remove_add, action_after_remove_add_fn,
  _show_popup_compare, show_popup_compare_fn,
  _conver_to_link;
class Wishlist extends btnTooltip {
  constructor() {
    super();
    getterAdd(_wishlist_id, this, this.dataset.id);
    getterAdd(_wishlist_handle, this, this.dataset.handle);
    getterAdd(_update_wis_text, this);
    getterAdd(_update_wis_btns, this);
    getterAdd(_click_wis, this);
    getterAdd(_add_wis, this);
    getterAdd(_remove_wis, this);
    getterAdd(_action_after_remove_add, this);
    getterAdd(_show_popup_compare, this);
    getterAdd(_conver_to_link, this);
    this.tabIndex = 0;
    this.addEventListener("click", (event) => getterRunFn(_click_wis, this, click_wis_fn).call(this, event));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_click_wis, this, click_wis_fn).call(this, event)
    });
  }
  static get observedAttributes() {
    return ["action"];
  }
  get isFnWishlist() {
    return true;
  }
  get textFn() {
    return 'wishlist';
  }
  get isPageWishlistorCompare() {
    //add code check page
    return this.isFnWishlist ? window.isPageWishlist : window.isPageCompare;
  }
  get limit() {
    return this.isFnWishlist ? limitWishlist : limitCompare;
  }
  get nameCached() {
    return this.isFnWishlist ? nameCachedWishlist : nameCachedCompare;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get actionAfterAdded() {
    return this.isFnWishlist ? actionAfterWishlistAdded : actionAfterCompareAdded;
  }
  get action() {
    return this.getAttribute('action');
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || (oldValue === null && newValue === 'add')) return;
    getterRunFn(_update_wis_text, this, update_wis_text_fn).call(this, newValue);
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.array.indexOf(getterGet(_wishlist_id, this)) > -1) {
      if (this.hasAttribute('remove-on-page')) {
        return
      }
      this.setAttribute('action', this.actionAfterAdded);
    }
  }
};
_wishlist_id = new WeakMap();
_wishlist_handle = new WeakMap();
_update_wis_text = new WeakSet();
_update_wis_btns = new WeakSet();
_click_wis = new WeakSet();
_add_wis = new WeakSet();
_remove_wis = new WeakSet();
_action_after_remove_add = new WeakSet();
_conver_to_link = new WeakSet();
_show_popup_compare = new WeakSet();
update_wis_text_fn = function (value) {
  if (this.hasAttribute('remove-on-page')) return;
  const text = themeHDN.extras[`text_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`],
    icon = themeHDN.extras[`icon_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`];
  if (icon) this.firstElementChild.replaceWith(document.createRange().createContextualFragment(icon));
  if (text) {
    this.lastElementChild.textContent = text;
    this.setAttribute('data-txt-tt',text)
  }
};
update_wis_btns_fn = function (_action) {
  // Update Button
  $$4(`hdt-${this.textFn}[data-id="${getterGet(_wishlist_id, this)}"]`).forEach(btn => {
    btn.setAttribute('action', _action);
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.textFn}:update`, {
    bubbles: true,
    detail: 'the4'  // arr_wishlist_list
  }));
  if ((window.isPageWishlist)) themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
};
click_wis_fn = function (e) {

  if (this.action == 'add') {
    // ADD
    getterRunFn(_add_wis, this, add_wis_fn).call(this);
  } else if (this.action === 'added') {
    // ADDED: go to page wishlist
    if (!this.isFnWishlist && themeHDN.extras.enableComparePopup) {
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    } else {
      window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
  } else {
    // REMOVE
    getterRunFn(_remove_wis, this, remove_wis_fn).call(this, e);
  }
};
add_wis_fn = function (e) {
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      if(this.isFnWishlist) {
        arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_wishlist_list)) {
          arr_wishlist_list = arr_wishlist_list.split(',');
        }
      }
      if (!this.isFnWishlist) {
        arr_compare_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_compare_list)) {
          arr_compare_list = arr_compare_list.split(',');
        }
        getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  }
  else {
    // local wishlist
    // adds the specified elements to the beginning of an array
    this.array.unshift(getterGet(_wishlist_id, this));
    //console.log(this.array, getterGet(_wishlist_id, this))
    if (this.array.length > this.limit) {
      // if over limit remove element on last array
      let arraySplice = this.array.splice(this.limit, 1);
      // arraySplice: allway has 1 element
      $$4(`hdt-${this.textFn}[data-id="${arraySplice[0]}"]`).forEach(btn => {
        btn.setAttribute('action', 'add');
      });
    }
    if (!this.isFnWishlist) getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    localStorage.setItem(this.nameCached, this.array.toString());
  }
};
remove_wis_fn = function (e) {
  e.preventDefault();
  e.stopPropagation();
  // REMOVE
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add',
        _method: 'DELETE'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
      if (!Array.isArray(arr_wishlist_list)) {
        arr_wishlist_list = arr_wishlist_list.split(',');
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  } else {
    // local wishlist
    this.array.splice(this.array.indexOf(getterGet(_wishlist_id, this)), 1);
    localStorage.setItem(this.nameCached, this.array.toString());

    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
  }
};
action_after_remove_add_fn = function (action) {

  if (this.getAttribute('action') == 'remove' && this.hasAttribute('remove-on-page')) {
    if (this.isFnWishlist) {
      this.closest('.hdt-card-product').remove();
    } else {
      $$4(`.hdt-compare-item-${getterGet(_wishlist_id, this)}`).forEach(item => {
        item.remove();
        // console.log("Remove compare item");
      });
    }
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    if (this.array.length == 0) {
      $id4('drawerCompare')?.closest('hdt-drawer')?.close();
      if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
    //this.setAttribute('action', action);
  } else {
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    // is page wishlist or compare reload page
    if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
  }
};
show_popup_compare_fn = function (event) {
  if (!themeHDN.extras.enableComparePopup || this.isPageWishlistorCompare) return;
  // add code if want show popup compare
  $id4('drawerCompare')?.closest('hdt-drawer')?.open();
  fetch(conver_to_link_fn('compare', arr_compare_list) + "&section_id=compare-offcanvas")
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const prds = html.querySelector('offcanvas-compare');

      if (prds && prds.innerHTML.trim().length) {

        $4("offcanvas-compare").innerHTML = prds.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};
var _clear_all, clear_all_fn;
class ClearAll extends HTMLElement {
  constructor() {
    super();
    getterAdd(_clear_all, this);
    this.tabIndex = 0;
    this.addEventListener("click", getterRunFn(_clear_all, this, clear_all_fn));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_clear_all, this, clear_all_fn).call(this)
    });
  }
  get ofFn() {
    return this.getAttribute('of-fn'); //'compare', 'wishlist'
  }
  get nameCached() {
    return this.ofFn == 'compare' ? nameCachedCompare : nameCachedWishlist;
  }
  set array(value) {
    this.ofFn == 'compare' ? arr_compare_list = value : arr_wishlist_list = value;
  }
};
_clear_all = new WeakSet();
clear_all_fn = function () {
  localStorage.removeItem(this.nameCached);
  // Update Buttons
  $$4(`hdt-${this.ofFn}[action="added"]`).forEach(btn => {
    btn.setAttribute('action', 'add');
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.ofFn}:update`, {
    bubbles: true,
    detail: 'the4'
  }));
  this.array = [];
  $id4(`drawerCompare`)?.closest('hdt-drawer')?.close();
  if ($4(`#drawerCompare offcanvas-compare`)){
    $4(`#drawerCompare offcanvas-compare`).innerHTML = "";
  }
};
customElements.define("hdt-clear-all", ClearAll);
// eg: <hdt-clear-all role="button" of-fn="compare">Clear All </hdt-clear-all>

// Update count
class WishlistCount extends HTMLElement {
  constructor() {
    super();
    this.textContent = this.array.length;
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      //console.log(this.prefix + ' count update.');
      this.textContent = this.array.length;
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
// Update link page
class WishlistLink extends HTMLElement {
  constructor() {
    super();
    $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    //console.log('WishlistLink', this.href)
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
customElements.define("hdt-wishlist", Wishlist);
customElements.define("hdt-wishlist-count", WishlistCount);
customElements.define("hdt-wishlist-a", WishlistLink);

// COMPARE
class Compare extends Wishlist {
  get isFnWishlist() {
    return false;
  }
  get textFn() {
    return 'compare';
  }
}
// Update count
class CompareCount extends WishlistCount {
  get isFnWishlist() {
    return false;
  }
}
// Update link page
class CompareLink extends WishlistLink {
  get isFnWishlist() {
    return false;
  }
}
customElements.define("hdt-compare", Compare);
customElements.define("hdt-compare-count", CompareCount);
customElements.define("hdt-compare-a", CompareLink);

// footer accodion
function handleAccordionClick() {
  let accordion = this.parentElement;
  accordion.classList.toggle('open');
  if (window.innerWidth < 768) {
    let content = accordion.querySelector('.hdt-collapse-content');
    if (accordion.classList.contains('open')) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0';
    }
  }
}
function updateMaxHeight() {
  if (window.innerWidth >= 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-collapse-content').forEach(function(content) {
      content.style.height = '';
    });
  }
}
document.querySelectorAll('.hdt-footer-section .hdt-footer-heading').forEach(function(element) {

  element.addEventListener('click', handleAccordionClick);
});
window.addEventListener('resize', function() {
  if (window.innerWidth < 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-footer-heading').forEach(function(element) {
      element.removeEventListener('click',handleAccordionClick);
      element.addEventListener('click',handleAccordionClick);
    });
  } else {
    document.querySelectorAll('.hdt-footer-section .hdt-footer-heading').forEach(function(element) {
      element.removeEventListener('click',handleAccordionClick);
    });
    updateMaxHeight();
  }
});


// --------------------------
// Back to top
// --------------------------
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (window.innerWidth < 768 && this.config.hiddenMobile) return;
    this.debounce_timer = 0;
    this.debounce_timer2 = 0;
    this.circlechart = this.querySelector('.hdt-circle-css');
    this.addEventListener("click", this.goTop.bind(this));
    window.addEventListener("scroll", this.backToTop.bind(this));
  }
  goTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  backToTop() {
    let self = this;
    if (this.debounce_timer) { clearTimeout(this.debounce_timer); }
    this.debounce_timer = setTimeout(function () {
      if (window.scrollY > self.config.scrollTop) {
        self.classList.add('is--show');
      } else {
        self.classList.remove('is--show');
      }
    }, 40);

    if (!this.circlechart) return;

    if (this.debounce_timer2) { clearTimeout(this.debounce_timer2); }

    this.debounce_timer2 = setTimeout(function () {
      let scrollTop2 = window.scrollY,
        docHeight = document.body.offsetHeight,
        winHeight = window.innerHeight,
        scrollPercent = scrollTop2 / (docHeight - winHeight),
        degrees = scrollPercent * 360;
      self.circlechart.style.setProperty("--cricle-degrees", degrees + 'deg');
    }, 6);
  }
}

customElements.define('back-to-top', BackToTop);

// --------------------------
// Form status
// --------------------------


const contactForm = $$4('form[action^="/contact"]');
contactForm.forEach(function(form) {
  form.addEventListener("submit", function(event){
    sessionStorage.setItem("the4:recentform", this.getAttribute("id"));
  })
});
var recentform = sessionStorage.getItem("the4:recentform") || "";

if (location.href.indexOf('contact_posted=true') > 0 && recentform !== "") {
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
  if (recentform.indexOf('ContactFormAsk') >= 0 && $id4(recentform).length > 0) {
    let modal_id = document.getElementById(recentform).getAttribute('data-modal');
    document.getElementById(modal_id).setAttribute('open','')
  }
  if ($4('.form-status-mirror-'+ recentform)) {
    $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
  }
}

else if (location.href.indexOf('customer_posted=true') > 0 && recentform !== "") {
  document.addEventListener('the4:recentform', (event)=>{
    let modal_id = document.getElementById(event.detail.recentform).getAttribute('data-id');
    document.getElementById(modal_id).setAttribute('open','')
  })
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
}
else if (location.href.indexOf('contact_posted=true') > 0 && location.href.indexOf('#') > 0 ) {
  var recentform = location.href.split("#")[1];
  if ($id4(recentform).length > 0) {
    sessionStorage.setItem("the4:recentform", recentform);
    $id4(recentform).classList.add("on-live");
    if ($4('.form-status-mirror-'+ recentform)) {
      $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
    }
  }
}

// --------------------------
// numberRandom
// --------------------------
class numberRandom extends HTMLElement {
  constructor() {
    super();
    let config = JSON.parse(this.getAttribute("config"));
    this.min = config.min;
    this.max = config.max;
    this.interval = config.interval;
    this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    this.ofset = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"];
    this.prioritize = ["10", "20", "15"];
    this.h = "";
    this.e = "";
    this.M = "";
    this.liveViewInt();
    setInterval(this.liveViewInt.bind(this), this.interval);
  }

  liveViewInt() {
    if (this.h = Math.floor(Math.random() * this.ofset.length), this.e = this.ofset[this.h], this.number = parseInt(this.number) + parseInt(this.e), this.min >= this.number) {
      this.M = Math.floor(Math.random() * this.prioritize.length);
      var a = this.prioritize[this.M];
      this.number += a
    }
    if (this.number < this.min || this.number > this.max) {
      this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    }
    this.innerHTML = parseInt(this.number);
  }
}

customElements.define('number-random', numberRandom);

// --------------------------
// Total sold flash
// --------------------------
class flashSold extends VariantChangeBase {
  constructor() {
    super();
    var self = this;
    this.time = this.getAttribute("time");
    this.config = JSON.parse(this.getAttribute("flash-sold"));
    this.mins = this.config.mins;
    this.maxs = this.config.maxs;
    this.mint = this.config.mint;
    this.maxt = this.config.maxt;
    this.dataID = this.config.id;
    this.getS = sessionStorage.getItem("soldS" + this.dataID) || this.getRandomInt(this.mins, this.maxs);
    this.getT = sessionStorage.getItem("soldT" + this.dataID) || this.getRandomInt(this.mint, this.maxt);
    this.numS = parseInt(this.getS);
    this.numT = parseInt(this.getT);
    this.intervalTime = parseInt(this.config.time);
    this.$sold = this.querySelector('[data-sold]');
    this.$hour = this.querySelector('[data-hour]');
    this.limitMinMax();
    this.updateSold(this.numS, this.numT);
    setInterval(function () {
      this.numS = this.numS + self.getRandomInt(1, 4);
      this.numT = this.numT + (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1) * 1;
      self.limitMinMax();
      self.updateSold(self.numS, self.numT);
    }, this.intervalTime);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  updateSold(num1, num2) {
    this.$sold.innerHTML = num1;
    this.$hour.innerHTML = Math.floor(this.numT);
    sessionStorage.setItem("soldS" + this.dataID, num1);
    sessionStorage.setItem("soldT" + this.dataID, num2);
  }
  limitMinMax() {
    if (this.numS > this.maxs) this.numS = self.getRandomInt(this.mins, this.maxs)
    if (this.numT > this.maxt) this.numT = self.getRandomInt(this.mins, this.maxt)
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = "block"
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('flash-sold', flashSold);

// ======================================
//    pages/brands -  filter isotope 
// ======================================
class filterIsotope extends HTMLElement{
  constructor(){
    super();
    this.btns = this.querySelectorAll('button');
    this.id = this.id;
    if(!this.btns){
      return;
    }
    this.handleButtonClick();
  }
  handleButtonClick(){
    this.btns.forEach(btn =>{
      btn.addEventListener('click',()=>{
        this.querySelector('button.active').classList.remove('active');
        btn.classList.add('active');

        let selectedFilter = btn.getAttribute('data-filter');
        let itemsToHide = $$4(`#${this.id} .hdt-brand-item:not(${selectedFilter})`);
        let itemsToShow = $$4(`#${this.id} ${selectedFilter}`);

        if (selectedFilter == '._filter-show-all') {
          itemsToHide = [];
          itemsToShow = $$4(`#${this.id} .hdt-brand-item`);
        }
        console.log(`#${this.id} ${selectedFilter}`);

        itemsToShow.forEach(el => {
          el.classList.remove('animate-filter-hide','hdt-hidden');
          el.classList.add('animate-filter-show'); 
        });
        
        itemsToHide.forEach(el => {
          el.classList.add('animate-filter-hide','hdt-hidden');
          el.classList.remove('animate-filter-show');
        });
      })
    })
  }
}
customElements.define('hdt-brands',filterIsotope);

// ======================================
//   countryFilter 
// ======================================
class countryFilter extends HTMLElement {
  constructor() {
    super();
    this.search = $4('[name=country_filter]', this);
    this.reset = $4(".hdt-country_filter__reset", this);
    if (this.search) {
      this.search.addEventListener(
        'input',
        debounce((event) => {
          this.filterCountries();
        }, 200).bind(this)
      );
    }
    this.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));

  }
  filterCountries(){
    const searchValue = this.search.value.toLowerCase();
    const allCountries = this.closest("hdt-popover").querySelectorAll('hdt-richlist button');
    let visibleCountries = allCountries.length;
    allCountries.forEach((item) => {
      const countryName = item.getAttribute('data-name').toLowerCase();
      if (countryName.indexOf(searchValue) > -1) {
        console.log(1)
        item.classList.remove('hdt-d-none');
        visibleCountries++;
      } else {
        console.log(2)
        item.classList.add('hdt-d-none');
        visibleCountries--;
      }
    });
    this.closest("hdt-popover").updatePos();
    this.closest("hdt-popover").shadowRoot.querySelector('.hdt-current-scrollbar').scrollTop = 0;
  }

  onSearchKeyDown(event) {
    if (event.code.toUpperCase() === 'ENTER') {
      event.preventDefault();
    }
  }
}

customElements.define('country-filter', countryFilter);



// --------------------------
// Product Recommendations
// --------------------------
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          document.dispatchEvent(new CustomEvent("currency:update"));
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// --------------------------
// Product Recently
// --------------------------
class ProductRecently extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let handleProducts = localStorage.getItem("theme4:recently:id");
      let prdId = this.dataset.id;

      if (handleProducts !== null) {
        let products = handleProducts.split(',');
        let url = this.dataset.url.replace('q=', 'q=id:' + products.join("%20OR%20id:"));
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recently = html.querySelector('product-recently');

            if (recently && recently.innerHTML.trim().length) {
              this.innerHTML = recently.innerHTML;
            }
            document.dispatchEvent(new CustomEvent("currency:update"));
          })
          .catch((e) => {
            console.error(e);
          });

      }
      let arrayProducts = handleProducts !== null ? handleProducts.split(',') : new Array;
      if (!arrayProducts.includes(prdId + '')) {
        if (arrayProducts.length >= 10) {
          arrayProducts.pop();
        }
        function prepend(value, array) {
          var newArray = array.slice();
          newArray.unshift(value);
          return newArray;
        }
        arrayProducts = prepend(prdId, arrayProducts);
        arrayProducts = arrayProducts.toString();
        localStorage.setItem("theme4:recently:id", arrayProducts);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recently', ProductRecently);


// --------------------------
// Product Ask Question
// --------------------------

const modalAsk = document.getElementById('modal-contactFormAsk');
modalAsk.addEventListener('dialog:beforeOpen', function(event) {
  let askBtn = document.querySelectorAll('[aria-controls="modal-contactFormAsk"][aria-expanded="true"]')
  let product = askBtn[askBtn.length - 1].getAttribute('data-product');
  let productAsk = modalAsk.querySelector('[name="contact[product]"]');
  if (productAsk) {
    let currentValue = productAsk.value || '';
    let newValue = product || '';
    
    if (currentValue !== newValue) {
      let formMessage = modalAsk.querySelector('.hdt-form-message');
      if (formMessage) {
        formMessage.remove();
      }
    }
    if (currentValue !== newValue || currentValue === '') {
      productAsk.value = newValue;
    }
  }
})

// --------------------------
// Predictive Search
// --------------------------
class PredictiveSearch extends DrawerComponent {
  constructor() {
    super();
    // console.log(!this.hasAttribute('enabled'))
    if (!this.hasAttribute('enabled')) return;
    
    // Initialize RTL configuration similar to Deal Cosmetics approach
    this.initRTLConfig();
    
    // Clear any cached results to ensure fresh search results
    this.cachedResults = {};
    
    // Clear localStorage cache if it exists
    try {
      localStorage.removeItem('predictive_search_cache');
    } catch(e) {};
    this.predictiveSearchResults = $4('[data-results-search]', this);
    this.select = $4('[data-cat-search]>select', this);
    this.input = $4('input[type="search"]', this);
    this.sectionIdResults = this.getAttribute('data-section-id-results') || 'hdt_predictive-search';
    this.allPredictiveSearchInstances = $$4('predictive-search');
    this.skeleton = $4('[data-skeleton-search]', this);
    this.noResults = $4('.hdt-cart-no-results', this);
    this.hideWrapper = $4('.hdt-cart-hide-has-results', this);
    this.showWrapper = $4('.hdt-cart-show-has-results', this);
    this.btn_viewall = $4('.hdt-view_all', this);
    this.href = this.btn_viewall?.getAttribute("href");
    this.btn_viewall_replace_text = $4('[data-replace-text]',this);
    this.isOpen = false;
    this.abortController2 = new AbortController();
    this.searchTerm = '';

    if (this.input) {
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
    if (this.select) {
      this.select.addEventListener(
        'change',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    const formData = new FormData(this.input.form);
    this.params = "";
    for (const [key, value] of formData) {
      if (key === 'q') break;
      this.params += `${key}=${value}&`;
    }

    // Setup RTL-aware input handling
    this.setupRTLInputHandling();

    this.setupEventListeners();
  }

  initRTLConfig() {
    // RTL detection similar to Deal Cosmetics approach
    if (!window.theme) window.theme = {};
    if (!window.theme.config) {
      window.theme.config = {
        rtl: document.documentElement.getAttribute("dir") === "rtl" || 
             document.documentElement.getAttribute("lang") === "he" ||
             document.documentElement.classList.contains("rtl")
      };
    }
    this.isRTL = window.theme.config.rtl;
    this.isHebrew = document.documentElement.getAttribute("lang") === "he" || this.detectHebrewInterface();
  }

  detectHebrewInterface() {
    // Check if interface is in Hebrew by looking for Hebrew text in common elements
    const titleElement = document.querySelector('title');
    if (titleElement && this.containsHebrew(titleElement.textContent)) return true;
    
    const navElements = document.querySelectorAll('nav, .header, [role="navigation"]');
    for (let element of navElements) {
      if (this.containsHebrew(element.textContent)) return true;
    }
    
    return false;
  }

  containsHebrew(text) {
    // Check if text contains Hebrew characters
    if (!text || typeof text !== 'string') return false;
    return /[\u0590-\u05FF]/.test(text);
  }

  normalizeHebrewQuery(query) {
    // Enhanced Hebrew text normalization similar to Deal Cosmetics
    if (!query || typeof query !== 'string') return '';
    
    // Basic normalization
    let normalized = query.trim().toLowerCase();
    
    // Remove Hebrew vowels (nikkud) for better matching
    normalized = normalized.replace(/[\u05B0-\u05C7]/g, '');
    
    // Normalize Hebrew final letters to regular forms for search consistency
    const finalLetterMap = {
      'ך': 'כ', 'ם': 'מ', 'ן': 'נ', 'ף': 'פ', 'ץ': 'צ'
    };
    
    normalized = normalized.replace(/[ךםןףץ]/g, match => finalLetterMap[match] || match);
    
    return normalized;
  }

  setupRTLInputHandling() {
    if (!this.input) return;
    
    // Set RTL attributes when Hebrew is detected
    if (this.isRTL || this.isHebrew) {
      this.input.setAttribute('dir', 'rtl');
      this.input.style.textAlign = 'right';
      this.input.style.direction = 'rtl';
      
      // Add RTL class to container for styling
      this.classList.add('hdt-search-rtl');
    }

    // Dynamic RTL switching based on input content
    this.input.addEventListener('input', (e) => {
      const inputValue = e.target.value.trim();
      if (inputValue.length > 0) {
        const isHebrewText = this.containsHebrew(inputValue);
        const direction = isHebrewText ? 'rtl' : 'ltr';
        const textAlign = isHebrewText ? 'right' : 'left';
        
        e.target.setAttribute('dir', direction);
        e.target.style.direction = direction;
        e.target.style.textAlign = textAlign;
        
        // Update results container direction
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.setAttribute('dir', direction);
          this.predictiveSearchResults.style.direction = direction;
        }
        
        // Toggle RTL class on search container
        if (isHebrewText) {
          this.classList.add('hdt-search-rtl');
        } else {
          this.classList.remove('hdt-search-rtl');
        }
      }
    });
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    var currentValue = this.input.value.trim();
    
    console.log('Raw input value:', currentValue, `(chars: ${currentValue.split('').map(c => c.charCodeAt(0)).join(',')})`, `Hebrew detected: ${this.containsHebrew(currentValue)}`);
    
    // DON'T normalize here - let search strategies handle normalization
    // This ensures we preserve original Hebrew input for better search matching
    
    if (this.select) {
      this.selectVal = this.select.value || '*';
      var valSelected = this.selectVal.trim();
      //console.log(valSelected)
      if (valSelected != '*') {
        if(currentValue !== '') {
          currentValue = `product_type:${valSelected} AND ${currentValue}`;
        } else {
          currentValue = `product_type:${valSelected}`;
        }
      }
    }

    return currentValue;
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    // console.log(newSearchTerm)
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    this.btn_viewall?.setAttribute("href", this.href.replace(/\/search\?q=.*/g, "/search?q=" + this.searchTerm));
    this.btn_viewall_replace_text ? this.btn_viewall_replace_text.innerText = themeHDN.extras.search.view_all + ` ${this.searchTerm}` : null;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.openSearch();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    // switch (event.code) {
    //   case 'ArrowUp':
    //     this.switchOption('up');
    //     break;
    //   case 'ArrowDown':
    //     this.switchOption('down');
    //     break;
    //   case 'Enter':
    //     this.selectOption();
    //     break;
    // }
  }

  // onKeydown(event) {
  //   // Prevent the cursor from moving in the input when using the up and down arrow keys
  //   if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
  //     event.preventDefault();
  //   }
  // }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.searchTerm = searchTerm;
    this.setLiveRegionLoadingState();

    // Check cache first
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    console.log('Search execution:', {
      searchTerm: searchTerm,
      queryKey: queryKey,
      isHebrew: this.containsHebrew(searchTerm)
    });
    
    // Use robust search strategy with fallback for cross-language compatibility
    this.performRobustSearch(searchTerm, queryKey);
  }

  async getHebrewOptimizedSearchResults(searchTerm, queryKey) {
    // Try multiple search strategies for Hebrew - now including Deal Cosmetics predictive approach
    const strategies = [
      () => this.tryPredictiveSearchWithHebrewHeaders(searchTerm, queryKey),
      () => this.tryRegularSearchWithHebrewOptimizations(searchTerm, queryKey),
      () => this.tryFallbackHebrewSearch(searchTerm, queryKey),
      () => this.tryDirectHebrewSearch(searchTerm, queryKey)
    ];

    for (const strategy of strategies) {
      try {
        const success = await strategy();
        if (success) {
          return; // Successfully found results
        }
      } catch (error) {
        console.warn('Hebrew search strategy failed:', error);
        continue; // Try next strategy
      }
    }

    // If all strategies fail, show no results
    this.renderNoResults(searchTerm);
  }

  async tryDirectHebrewSearch(searchTerm, queryKey) {
    try {
      // Direct approach: navigate to search page and extract results
      // This mimics what happens when user submits search form directly
      console.log('Direct Hebrew search for:', searchTerm, `(chars: ${searchTerm.split('').map(c => c.charCodeAt(0)).join(',')})`);
      
      const searchForm = new FormData();
      searchForm.append('q', searchTerm);
      searchForm.append('type', 'product');
      
      // Use POST method like a form submission to avoid URL encoding issues
      const response = await fetch(themeHDN.routes.search_url, {
        method: 'POST',
        body: searchForm
      });
      
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const products = await this.extractProductsFromSearchResults(doc, searchTerm);
        
        if (products.length > 0) {
          console.log(`Direct search found ${products.length} products for: "${searchTerm}"`);
          const predictiveHTML = this.createPredictiveSearchHTML(products, searchTerm);
          this.cachedResults[queryKey] = predictiveHTML;
          this.renderSearchResults(predictiveHTML);
          this.setAttribute('results', true);
          return true;
        }
      } else {
        console.warn(`Direct search failed with status: ${response.status}`);
      }
      
      return false;
      
    } catch (error) {
      console.warn('Direct Hebrew search failed:', error);
      return false;
    }
  }

  async tryPredictiveSearchWithHebrewHeaders(searchTerm, queryKey) {
    try {
      // Use Deal Cosmetics exact approach for predictive search
      console.log('Trying Deal Cosmetics approach for Hebrew term:', searchTerm, `(chars: ${searchTerm.split('').map(c => c.charCodeAt(0)).join(',')})`);
      
      const searchObj = {
        'q': searchTerm,
        'resources[type]': 'product',
        'resources[limit]': 8,
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor'
      };
      
      // Build URL parameters manually like Deal Cosmetics
      const paramUrl = Object.keys(searchObj).map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(searchObj[key]);
      }).join('&');
      
      const searchUrl = `/search/suggest.json?${paramUrl}`;
      
      console.log(`Hebrew predictive search URL: ${searchUrl}`);
      
      const response = await fetch(searchUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        console.warn(`Predictive search failed with status: ${response.status} for Hebrew term: ${searchTerm}`);
        return false; // Fall back to next strategy
      }
      
      const suggestions = await response.json();
      
      console.log('Predictive search JSON response:', suggestions);
      
      // Debug the first product to understand structure
      if (suggestions.resources && suggestions.resources.results && suggestions.resources.results.products && suggestions.resources.results.products[0]) {
        console.log('First product structure:', suggestions.resources.results.products[0]);
      }
      
      // Extract products from JSON response like Deal Cosmetics
      if (suggestions.resources && suggestions.resources.results && suggestions.resources.results.products) {
        const products = suggestions.resources.results.products;
        
        if (products.length > 0) {
          console.log(`Found ${products.length} products via predictive search JSON for: "${searchTerm}"`);
          
          // Create predictive HTML from JSON data
          const predictiveHTML = this.createPredictiveSearchHTMLFromJSON(products, searchTerm);
          this.cachedResults[queryKey] = predictiveHTML;
          this.renderSearchResults(predictiveHTML);
          this.setAttribute('results', true);
          return true;
        }
      }
      
      return false; // No results in JSON
      
    } catch (error) {
      console.warn('Hebrew predictive search JSON failed:', error);
      return false;
    }
  }

  async tryRegularSearchWithHebrewOptimizations(searchTerm, queryKey) {
    try {
      // Create multiple normalized versions of the search term for better matching
      const searchVariants = [
        searchTerm, // Original term
        this.normalizeHebrewQuery(searchTerm), // Normalized term
        searchTerm.replace(/\s+/g, ' ').trim() // Clean whitespace
      ];
      
      // Remove duplicates
      const uniqueVariants = [...new Set(searchVariants)];
      
      for (const variant of uniqueVariants) {
        const searchParams = new URLSearchParams();
        searchParams.set('q', variant);
        searchParams.set('type', 'product');
        // Remove options[prefix] as it might cause issues with Hebrew
        
        const searchUrl = `${themeHDN.routes.search_url}?${searchParams.toString()}`;
        
        console.log('Hebrew regular search variant:', variant, `(chars: ${variant.split('').map(c => c.charCodeAt(0)).join(',')})`);
        
        // Use simpler headers to avoid encoding issues
        const response = await fetch(searchUrl, {
          method: 'GET',
          headers: {
            'Accept': 'text/html',
            'Cache-Control': 'no-cache'
          }
        });
        
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          const products = await this.extractProductsFromSearchResults(doc, searchTerm);
          
          if (products.length > 0) {
            console.log(`Found ${products.length} products for Hebrew search: "${variant}"`);
            const predictiveHTML = this.createPredictiveSearchHTML(products, searchTerm);
            this.cachedResults[queryKey] = predictiveHTML;
            this.renderSearchResults(predictiveHTML);
            this.setAttribute('results', true);
            return true;
          }
        } else {
          console.warn(`Search request failed for "${variant}" with status: ${response.status}`);
        }
      }
      
      return false; // No results found
      
    } catch (error) {
      console.warn('Hebrew regular search failed:', error);
      return false;
    }
  }

  async tryFallbackHebrewSearch(searchTerm, queryKey) {
    try {
      // Last resort: ultra-simple search that should always work
      // Use basic URL construction to avoid encoding issues
      const encodedSearchTerm = encodeURIComponent(searchTerm);
      const searchUrl = `${themeHDN.routes.search_url}?q=${encodedSearchTerm}`;
      
      console.log('Hebrew fallback search for:', searchTerm, `(encoded: ${encodedSearchTerm})`);
      
      // Minimal fetch request to avoid any header-related issues
      const response = await fetch(searchUrl, {
        method: 'GET'
      });
      
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const products = await this.extractProductsFromSearchResults(doc, searchTerm);
        
        if (products.length > 0) {
          console.log(`Fallback found ${products.length} products for: "${searchTerm}"`);
          const predictiveHTML = this.createPredictiveSearchHTML(products, searchTerm);
          this.cachedResults[queryKey] = predictiveHTML;
          this.renderSearchResults(predictiveHTML);
          this.setAttribute('results', true);
          return true;
        }
      } else {
        console.warn(`Fallback search failed with status: ${response.status}`);
      }
      
      return false;
      
    } catch (error) {
      console.warn('Hebrew fallback search failed:', error);
      return false;
    }
  }

  getRegularSearchResults(searchTerm, queryKey) {
    // Cancel previous search requests
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    
    // Simple cancellation using a timestamp
    this.searchTimestamp = Date.now();
    const currentTimestamp = this.searchTimestamp;
    
    // Use shorter debounce for responsive search
    this.searchTimeout = setTimeout(() => {
      // Only proceed if this is still the latest search request
      if (this.searchTimestamp === currentTimestamp) {
        this.performRegularSearch(searchTerm, queryKey, currentTimestamp);
      }
    }, 150); // Fast response for better UX
  }

  async performRobustSearch(searchTerm, queryKey) {
    // Try predictive search first, then fallback to regular search if it fails
    const strategies = [
      () => this.tryPredictiveSearch(searchTerm, queryKey),
      () => this.tryRegularSearchFallback(searchTerm, queryKey),
      () => this.tryDirectSearchFallback(searchTerm, queryKey)
    ];

    for (let i = 0; i < strategies.length; i++) {
      try {
        const success = await strategies[i]();
        if (success) {
          console.log(`Search strategy ${i + 1} succeeded for term: "${searchTerm}"`);
          return; // Successfully found results
        }
      } catch (error) {
        console.warn(`Search strategy ${i + 1} failed:`, error);
        continue; // Try next strategy
      }
    }

    // If all strategies fail, show no results
    console.log('All search strategies failed, showing no results');
    this.renderNoResults(searchTerm);
  }

  async tryPredictiveSearch(searchTerm, queryKey) {
    return new Promise((resolve) => {
      const urlParams = new URLSearchParams();
      urlParams.set('q', searchTerm);
      urlParams.set('resources[limit_scope]', 'each');
      urlParams.set('section_id', this.sectionIdResults);
      
      const searchUrl = `${themeHDN.routes.predictive_search_url}?${urlParams.toString()}`;
      
      console.log('Trying predictive search:', searchUrl);

      fetch(searchUrl)
      .then(response => {
        if (response.ok) {
          return response.text();
        } else {
          console.warn(`Predictive search failed with status: ${response.status}`);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      })
      .then(text => {
        console.log('Predictive search succeeded');
        this.cachedResults[queryKey] = text;
        this.renderSearchResults(text);
        this.setAttribute('results', true);
        resolve(true);
      })
      .catch(error => {
        console.log('Predictive search failed, will try fallback');
        resolve(false);
      });
    });
  }

  async tryRegularSearchFallback(searchTerm, queryKey) {
    try {
      console.log('Trying regular search fallback for:', searchTerm);
      
      const searchParams = new URLSearchParams();
      searchParams.set('q', searchTerm);
      searchParams.set('type', 'product');
      
      const searchUrl = `${themeHDN.routes.search_url}?${searchParams.toString()}`;
      
      const response = await fetch(searchUrl);
      
      if (!response.ok) {
        console.warn(`Regular search failed with status: ${response.status}`);
        return false;
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const products = await this.extractProductsFromSearchResults(doc, searchTerm);
      
      if (products.length > 0) {
        console.log(`Regular search fallback found ${products.length} products`);
        const predictiveHTML = this.createPredictiveSearchHTML(products, searchTerm);
        this.cachedResults[queryKey] = predictiveHTML;
        this.renderSearchResults(predictiveHTML);
        this.setAttribute('results', true);
        return true;
      }
      
      return false;
      
    } catch (error) {
      console.warn('Regular search fallback failed:', error);
      return false;
    }
  }

  async tryDirectSearchFallback(searchTerm, queryKey) {
    try {
      console.log('Trying direct search fallback for:', searchTerm);
      
      // Ultra-simple search approach
      const encodedSearchTerm = encodeURIComponent(searchTerm);
      const searchUrl = `${themeHDN.routes.search_url}?q=${encodedSearchTerm}`;
      
      const response = await fetch(searchUrl);
      
      if (!response.ok) {
        return false;
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const products = await this.extractProductsFromSearchResults(doc, searchTerm);
      
      if (products.length > 0) {
        console.log(`Direct search fallback found ${products.length} products`);
        const predictiveHTML = this.createPredictiveSearchHTML(products, searchTerm);
        this.cachedResults[queryKey] = predictiveHTML;
        this.renderSearchResults(predictiveHTML);
        this.setAttribute('results', true);
        return true;
      }
      
      return false;
      
    } catch (error) {
      console.warn('Direct search fallback failed:', error);
      return false;
    }
  }

  async performRegularSearch(searchTerm, queryKey, searchTimestamp) {
    try {
      // Check if this search is still current
      if (this.searchTimestamp !== searchTimestamp) {
        return;
      }
      
      // Show loading state immediately for better UX
      this.setLiveRegionLoadingState();
      
      // Use regular search API for all searches for better reliability
      await this.searchUsingRegularAPI(searchTerm, queryKey, searchTimestamp);
      
    } catch (error) {
      // Check if this search is still current before showing error
      if (this.searchTimestamp !== searchTimestamp) {
        return;
      }
      console.error('Regular search failed:', error);
      this.setLiveRegionResults();
      this.setAttribute('results', false);
    }
  }

  async searchUsingRegularAPI(searchTerm, queryKey, searchTimestamp) {
    try {
      // Check if this search is still current
      if (this.searchTimestamp !== searchTimestamp) {
        return;
      }
      
      // Use regular search API with optimized parameters for reliable results
      const searchParams = new URLSearchParams();
      searchParams.set('q', searchTerm);
      searchParams.set('type', 'product');
      searchParams.set('options[prefix]', 'last');
      
      const searchUrl = `${themeHDN.routes.search_url}?${searchParams.toString()}`;
      
      console.log(`Regular search using API for: "${searchTerm}"`);
      
      // Make request with proper headers for all languages
      const response = await fetch(searchUrl, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
          'Accept-Charset': 'utf-8',
          'Accept-Language': 'he,en;q=0.9',
          'Content-Type': 'text/html; charset=utf-8'
        }
      });
      
      // Check again if this search is still current
      if (this.searchTimestamp !== searchTimestamp) {
        return;
      }
      
      if (!response.ok) {
        throw new Error(`Regular search API failed: ${response.status}`);
      }
      
      const html = await response.text();
      
      // Final check if this search is still current
      if (this.searchTimestamp !== searchTimestamp) {
        return;
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract products from search results and convert to predictive search format
      const products = await this.extractProductsFromSearchResults(doc, searchTerm);
      
      console.log(`Found ${products.length} products for search: "${searchTerm}"`);
      
      if (products.length > 0) {
        // Convert to predictive search format
        const predictiveHTML = this.createPredictiveSearchHTML(products, searchTerm);
        this.cachedResults[queryKey] = predictiveHTML;
        this.renderSearchResults(predictiveHTML);
        this.setAttribute('results', true);
      } else {
        // No products found - show no results message
        this.renderNoResults(searchTerm);
      }
      
    } catch (error) {
      console.error('Regular search using API failed:', error);
      this.renderNoResults(searchTerm);
    }
  }

  async tryPredictiveHebrewSearch(searchTerm, queryKey, searchTimestamp) {
    try {
      // Check if this search is still current
      if (this.hebrewSearchTimestamp !== searchTimestamp) {
        return false;
      }
      
      // Properly encode Hebrew characters for URL
      const encodedSearchTerm = encodeURIComponent(searchTerm);
      
      // Use predictive search API with proper headers for Hebrew
      const urlParams = new URLSearchParams();
      urlParams.set('q', searchTerm); // URLSearchParams handles encoding automatically
      urlParams.set('resources[limit_scope]', 'each');
      urlParams.set('section_id', this.sectionIdResults);
      
      const searchUrl = `${themeHDN.routes.predictive_search_url}?${urlParams.toString()}`;
      
      // Make request with proper headers for UTF-8 encoding
      const response = await fetch(searchUrl, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
          'Accept-Charset': 'utf-8',
          'Accept-Language': 'he,en;q=0.9',
          'Content-Type': 'text/html; charset=utf-8'
        }
      });
      
      // Check again if this search is still current
      if (this.hebrewSearchTimestamp !== searchTimestamp) {
        return false;
      }
      
      // If we get 417 or other HTTP errors, return false to trigger fallback
      if (!response.ok) {
        console.warn(`Predictive search failed with status ${response.status} for Hebrew term: ${searchTerm}`);
        return false;
      }
      
      const text = await response.text();
      
      // Final check if this search is still current
      if (this.hebrewSearchTimestamp !== searchTimestamp) {
        return false;
      }
      
      // Process predictive search response
      const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
      this.cachedResults[queryKey] = parsedHTML.body.innerHTML;
      this.renderSearchResults(this.cachedResults[queryKey]);
      this.setAttribute('results', true);
      
      return true; // Success
      
    } catch (error) {
      console.warn('Predictive search error:', error);
      return false; // Failed, will trigger fallback
    }
  }

  async fallbackToRegularSearch(searchTerm, queryKey, searchTimestamp) {
    try {
      // Check if this search is still current
      if (this.hebrewSearchTimestamp !== searchTimestamp) {
        return;
      }
      
      // Use regular search API with Hebrew-optimized parameters
      const searchParams = new URLSearchParams();
      searchParams.set('q', searchTerm);
      searchParams.set('type', 'product');
      searchParams.set('options[prefix]', 'last');
      
      const searchUrl = `${themeHDN.routes.search_url}?${searchParams.toString()}`;
      
      // Make request with proper Hebrew headers
      const response = await fetch(searchUrl, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
          'Accept-Charset': 'utf-8',
          'Accept-Language': 'he,en;q=0.9',
          'Content-Type': 'text/html; charset=utf-8'
        }
      });
      
      // Check again if this search is still current
      if (this.hebrewSearchTimestamp !== searchTimestamp) {
        return;
      }
      
      if (!response.ok) {
        throw new Error(`Fallback search failed: ${response.status}`);
      }
      
      const html = await response.text();
      
      // Final check if this search is still current
      if (this.hebrewSearchTimestamp !== searchTimestamp) {
        return;
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract products from search results and convert to predictive search format
      const products = await this.extractProductsFromSearchResults(doc, searchTerm);
      
      if (products.length > 0) {
        // Convert to predictive search format
        const predictiveHTML = this.createPredictiveSearchHTML(products, searchTerm);
        this.cachedResults[queryKey] = predictiveHTML;
        this.renderSearchResults(predictiveHTML);
        this.setAttribute('results', true);
      } else {
        // No products found
        this.renderHebrewNoResults(searchTerm);
      }
      
    } catch (error) {
      console.error('Fallback search failed:', error);
      this.renderHebrewNoResults(searchTerm);
    }
  }

  async extractProductsFromSearchResults(doc, searchTerm) {
    const products = [];
    
    // Debug: Let's see what's actually in the search results page
    console.log('Search page title:', doc.title);
    console.log('Search page has products?', doc.querySelectorAll('a[href*="/products/"]').length, 'product links found');
    
    // Try theme-specific selectors first (based on main-search.liquid analysis)
    const productSelectors = [
      '.hdt-pr-style1, .hdt-pr-style2, .hdt-pr-style3, .hdt-pr-style4, .hdt-pr-style5, .hdt-pr-style6, .hdt-pr-style7, .hdt-pr-style8, .hdt-pr-style9, .hdt-pr-style10', // Theme-specific product cards
      '.hdt-card-product',  // General theme product card
      '.hdt-pr-item',
      '[data-product-id]',
      '.product-item',
      '.grid__item',
      '.product',
      '.search-result',
      'article[data-product-id]',
      '.card-wrapper',
      '.product-card',
      '.product-card-wrapper'
    ];
    
    let productElements = [];
    
    for (const selector of productSelectors) {
      productElements = doc.querySelectorAll(selector);
      if (productElements.length > 0) {
        console.log(`Found ${productElements.length} products using selector: ${selector}`);
        break;
      } else {
        console.log(`No products found with selector: ${selector}`);
      }
    }
    
    // If no products found with specific selectors, try finding by product links
    if (productElements.length === 0) {
      const productLinks = Array.from(doc.querySelectorAll('a[href*="/products/"]'));
      console.log(`Found ${productLinks.length} total product links in page`);
      
      if (productLinks.length > 0) {
        // Just use the product links themselves as containers
        productElements = productLinks.slice(0, 8); // Take first 8 links
        console.log(`Using ${productElements.length} product links directly as elements`);
      } else {
        console.log('No product links found in search results page');
      }
    }
    
    // Extract product data
    for (let i = 0; i < Math.min(productElements.length, 10); i++) { // Limit to 10 results
      const element = productElements[i];
      const product = this.extractProductData(element);
      if (product) {
        products.push(product);
      }
    }
    
    return products;
  }

  extractProductData(element) {
    try {
      // Find product link - handle case where element IS the link
      let productLink, productUrl;
      if (element.tagName === 'A' && element.href && element.href.includes('/products/')) {
        productLink = element;
        productUrl = element.href;
      } else {
        productLink = element.querySelector('a[href*="/products/"]');
        if (!productLink) return null;
        productUrl = productLink.href;
      }
      
      console.log('Extracting product data from:', productUrl);
      
      // Find product title with more specific selectors
      let title = '';
      
      if (element === productLink) {
        // If element IS the product link, get title from link text or nearby elements
        const linkText = productLink.textContent.trim();
        
        // Skip generic link text and look for actual product titles
        if (linkText && linkText !== 'product title' && linkText !== 'product words' && linkText.length > 3) {
          title = linkText;
        }
        
        // Try to find title in parent container or adjacent elements
        const parent = productLink.closest('.hdt-pr-item, .product-item, .grid__item, .card-wrapper, .product-card, .hdt-pr-style1, .hdt-pr-style2, .hdt-pr-style3, .hdt-pr-style4, .hdt-pr-style5, .hdt-pr-style6, .hdt-pr-style7, .hdt-pr-style8, .hdt-pr-style9, .hdt-pr-style10');
        if (parent && !title) {
          const titleSelectors = [
            '.hdt-card-product__title',
            '.hdt-pr-title-link',
            '.hdt-pr-title',
            '.product-title',
            'h2 a', 'h3 a', 'h4 a',
            '.title a',
            'a[data-instant]'
          ];
          
          for (const selector of titleSelectors) {
            const titleEl = parent.querySelector(selector);
            if (titleEl && titleEl.textContent.trim() && 
                titleEl.textContent.trim() !== 'product title' && 
                titleEl.textContent.trim() !== 'product words' &&
                titleEl.textContent.trim().length > 3) {
              title = titleEl.textContent.trim();
              break;
            }
          }
        }
      } else {
        // Normal title extraction for product containers with theme-specific selectors
        const titleSelectors = [
          '.hdt-card-product__title',     // Theme-specific product title
          '.hdt-pr-title-link',           // Theme product title link
          '.hdt-pr-title',                // Theme product title
          '.product-title',
          '.product-item__title',
          'h2 a', 'h3 a', 'h4 a',         // Title links in headings
          '.title a',
          'a[data-instant]'               // Theme uses data-instant for links
        ];
        
        for (const selector of titleSelectors) {
          const titleElement = element.querySelector(selector);
          if (titleElement && titleElement.textContent.trim() && 
              titleElement.textContent.trim() !== 'product title' && 
              titleElement.textContent.trim() !== 'product words' &&
              titleElement.textContent.trim().length > 3) {
            title = titleElement.textContent.trim();
            break;
          }
        }
        
        // Fallback to product link text but filter out generic text
        if (!title && productLink) {
          const linkText = productLink.textContent.trim();
          if (linkText && linkText !== 'product title' && linkText !== 'product words' && linkText.length > 3) {
            title = linkText;
          }
        }
      }
      
      // Final fallback - extract title from URL if nothing else works
      if (!title || title === 'product title' || title === 'product words') {
        const urlParts = productUrl.split('/products/');
        if (urlParts.length > 1) {
          const productHandle = urlParts[1].split('?')[0].split('#')[0];
          title = productHandle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        }
      }
      
      // Find product image with theme-specific selectors
      let img, imgSrc, imgAlt;
      
      const imageSelectors = [
        '.hdt-product-img img',          // Theme-specific product image
        '.hdt-card-product__media img',  // Theme card media
        '.product-img img',
        '.card__media img',
        'img'                            // Fallback to any image
      ];
      
      if (element === productLink) {
        // Look for images in parent container with theme-specific classes
        const parent = productLink.closest('.hdt-pr-item, .product-item, .grid__item, .card-wrapper, .product-card, .hdt-pr-style1, .hdt-pr-style2, .hdt-pr-style3, .hdt-pr-style4, .hdt-pr-style5, .hdt-pr-style6, .hdt-pr-style7, .hdt-pr-style8, .hdt-pr-style9, .hdt-pr-style10');
        
        if (parent) {
          for (const selector of imageSelectors) {
            img = parent.querySelector(selector);
            if (img && (img.src || img.dataset.src)) break;
          }
        }
        
        // Fallback to direct search
        if (!img) {
          img = productLink.querySelector('img');
        }
      } else {
        // Try theme-specific image selectors first
        for (const selector of imageSelectors) {
          img = element.querySelector(selector);
          if (img && (img.src || img.dataset.src)) break;
        }
      }
      
      // Extract image URL with lazy loading support
      imgSrc = '';
      if (img) {
        imgSrc = img.src || 
                img.dataset.src || 
                img.getAttribute('data-srcset')?.split(' ')[0] || 
                img.getAttribute('srcset')?.split(' ')[0] || '';
        
        // Handle relative URLs
        if (imgSrc && !imgSrc.startsWith('http') && !imgSrc.startsWith('//')) {
          imgSrc = new URL(imgSrc, window.location.origin).href;
        }
      }
      
      imgAlt = img ? (img.alt || title) : title;
      
      // Find product price with theme-specific selectors
      const priceSelectors = [
        '.hdt-price-wrapp .hdt-price .hdt-money',    // Theme-specific price structure
        '.hdt-money',                                // Theme money class
        '.price .money',                             // Standard Shopify price
        '.price',                                    // Generic price
        '.product-price',
        '.money',
        '.product-item__price',
        '[data-price]'
      ];
      
      let price = '';
      let price_min = null;
      let compare_at_price_min = null;
      
      if (element === productLink) {
        // Look for price in parent container
        const parent = productLink.closest('.hdt-pr-item, .product-item, .grid__item, .card-wrapper, .product-card, .hdt-pr-style1, .hdt-pr-style2, .hdt-pr-style3, .hdt-pr-style4, .hdt-pr-style5, .hdt-pr-style6, .hdt-pr-style7, .hdt-pr-style8, .hdt-pr-style9, .hdt-pr-style10');
        if (parent) {
          for (const selector of priceSelectors) {
            const priceElement = parent.querySelector(selector);
            if (priceElement) {
              price = priceElement.textContent.trim();
              
              // Extract numeric price for Shopify format
              const numericMatch = price.match(/[\d,]+\.?\d*/);
              if (numericMatch) {
                const numericPrice = parseFloat(numericMatch[0].replace(',', ''));
                if (!isNaN(numericPrice)) {
                  price_min = numericPrice * 100; // Convert to cents
                }
              }
              break;
            }
          }
          
          // Look for compare-at price
          const compareAtEl = parent.querySelector('.hdt-compare-at-price .hdt-money, .compare-at-price .money');
          if (compareAtEl && compareAtEl.textContent.trim()) {
            const compareAtPrice = compareAtEl.textContent.trim();
            const numericMatch = compareAtPrice.match(/[\d,]+\.?\d*/);
            if (numericMatch) {
              const numericPrice = parseFloat(numericMatch[0].replace(',', ''));
              if (!isNaN(numericPrice)) {
                compare_at_price_min = numericPrice * 100;
              }
            }
          }
        }
      } else {
        // Normal price extraction
        for (const selector of priceSelectors) {
          const priceElement = element.querySelector(selector);
          if (priceElement) {
            price = priceElement.textContent.trim();
            
            // Extract numeric price for Shopify format
            const numericMatch = price.match(/[\d,]+\.?\d*/);
            if (numericMatch) {
              const numericPrice = parseFloat(numericMatch[0].replace(',', ''));
              if (!isNaN(numericPrice)) {
                price_min = numericPrice * 100; // Convert to cents
              }
            }
            break;
          }
        }
      }
      
      const productData = {
        url: productUrl,
        title: title,
        image: imgSrc,
        imageAlt: imgAlt,
        price: price,
        price_min: price_min,
        compare_at_price_min: compare_at_price_min
      };
      
      console.log('Extracted product data:', {
        title: title,
        url: productUrl,
        price: price,
        hasPrice: !!price
      });
      return productData;
      
    } catch (error) {
      console.warn('Error extracting product data:', error);
      return null;
    }
  }

  createPredictiveSearchHTML(products, searchTerm) {
    if (products.length === 0) {
      return this.getNoResultsHTML(searchTerm);
    }
    
    // Use theme's default structure
    let html = '<div class="hdt-search-products">';
    html += '<h6 class="hdt-search-top-title hdt-font-medium">מוצרים</h6>';
    html += '<div class="hdt-search-results-list hdt-row-products hdt-show-pr-price-true hdt-current-scrollbar">';
    
    products.forEach(product => {
      html += '<div class="hdt-card-product hdt-pr-loop hdt-loop-item">';
      html += '<div class="hdt-card-product__wrapper hdt-flex hdt-loop-inner">';
      
      // Product image (matching pr_loop_item structure)
      if (product.image && typeof product.image === 'string') {
        let imageUrl = product.image;
        // Add sizing parameters for thumbnails
        if (!imageUrl.includes('width=')) {
          imageUrl += imageUrl.includes('?') ? '&width=80' : '?width=80';
        }
        
        html += '<div class="hdt-card-product__media hdt-loop-img hdt-relative hdt-oh">';
        html += '<div class="hdt-product-img hdt-ratio" style="--aspect-ratioapt: 1">';
        html += '<img src="' + imageUrl + '" alt="' + (product.imageAlt || product.title || 'Product image') + '" loading="lazy" width="80" height="80">';
        html += '</div>';
        html += '<a class="hdt-full-width-link" aria-label="link" href="' + product.url + '"></a>';
        html += '</div>';
      } else {
        // If no image, add placeholder div to maintain layout
        html += '<div class="hdt-card-product__media hdt-loop-img hdt-relative hdt-oh">';
        html += '<div class="hdt-product-img hdt-ratio" style="--aspect-ratioapt: 1; background: #f5f5f5;">';
        html += '<div style="width:80px;height:80px;display:flex;align-items:center;justify-content:center;color:#ccc;font-size:12px;">No Image</div>';
        html += '</div>';
        html += '<a class="hdt-full-width-link" aria-label="link" href="' + product.url + '"></a>';
        html += '</div>';
      }
      
      // Product info (matching pr_loop_item structure) - Ensure proper column layout
      html += '<div class="hdt-card-product__info" style="flex: 1; min-width: 0;">';
      html += '<a href="' + product.url + '" class="hdt-card-product__title hdt-text-base hdt-line-clamp hdt-loop-title" data-instant style="display: block; margin-bottom: 8px; color: inherit; text-decoration: none;">' + (product.title || 'Product') + '</a>';
      
      console.log("Processing HTML search result:", JSON.stringify(product));
      
      // Enhanced price handling using the same logic as JSON search
      let formattedPrice = this.formatShopifyPrice(product);
      
      if (formattedPrice) {
        html += '<div class="hdt-price-wrapp hdt-text-base hdt-font-medium" style="margin-top: 4px;">';
        html += '<div class="hdt-price__list">';
        
        // Check if product is on sale
        const isOnSale = product.compare_at_price_min && product.compare_at_price_min > product.price_min;
        if (isOnSale) {
          html += '<hdt-compare-at-price class="hdt-compare-at-price">';
          html += '<span class="hdt-money">' + this.formatPriceValue(product.compare_at_price_min) + '</span>';
          html += '</hdt-compare-at-price>';
        }
        
        html += '<hdt-price class="hdt-price">';
        html += '<span class="hdt-money" style="color: inherit; font-weight: 500;">' + formattedPrice + '</span>';
        html += '</hdt-price>';
        html += '</div>';
        html += '</div>';
      } else {
        console.log('No price found for HTML extracted product:', product.title);
        console.log('Available price fields:', {
          price: product.price,
          price_min: product.price_min,
          price_max: product.price_max
        });
      }
      
      html += '</div>'; // info
      html += '</div>'; // wrapper
      html += '</div>'; // card-product
    });
    
    html += '</div>'; // search-results-list
    html += '</div>'; // search-products
    
    return html;
  }

  createPredictiveSearchHTMLFromJSON(products, searchTerm) {
    if (products.length === 0) {
      return this.getNoResultsHTML(searchTerm);
    }
    
    // Use theme's default structure for JSON response
    let html = '<div class="hdt-search-products">';
    html += '<h6 class="hdt-search-top-title hdt-font-medium">מוצרים</h6>';
    html += '<div class="hdt-search-results-list hdt-row-products hdt-show-pr-price-true hdt-current-scrollbar">';
    
    products.forEach(product => {
      html += '<div class="hdt-card-product hdt-pr-loop hdt-loop-item">';
      html += '<div class="hdt-card-product__wrapper hdt-flex hdt-loop-inner">';
      
      // Product image - Handle JSON response image structure (matching pr_loop_item)
      let imageUrl = '';
      let imageAlt = product.title;
      
      // Handle different image structures from Shopify predictive search JSON
      if (product.image) {
        if (typeof product.image === 'string') {
          imageUrl = product.image;
        } else if (product.image.url) {
          imageUrl = product.image.url;
          imageAlt = product.image.alt || product.title;
        }
      } else if (product.featured_image) {
        if (typeof product.featured_image === 'string') {
          imageUrl = product.featured_image;
        } else if (product.featured_image.url) {
          imageUrl = product.featured_image.url;
        }
      }
      
      // Ensure imageUrl is a string and add sizing parameters
      if (imageUrl && typeof imageUrl === 'string') {
        // Add Shopify image sizing parameters for small predictive search thumbnails
        if (!imageUrl.includes('width=')) {
          imageUrl += imageUrl.includes('?') ? '&width=80' : '?width=80';
        }
        
        html += '<div class="hdt-card-product__media hdt-loop-img hdt-relative hdt-oh">';
        html += '<div class="hdt-product-img hdt-ratio" style="--aspect-ratioapt: 1">';
        html += '<img src="' + imageUrl + '" alt="' + imageAlt + '" loading="lazy" width="80" height="80">';
        html += '</div>';
        html += '<a class="hdt-full-width-link" aria-label="link" href="' + product.url + '"></a>';
        html += '</div>';
      } else {
        // If no image, add placeholder div to maintain layout
        html += '<div class="hdt-card-product__media hdt-loop-img hdt-relative hdt-oh">';
        html += '<div class="hdt-product-img hdt-ratio" style="--aspect-ratioapt: 1; background: #f5f5f5;">';
        html += '<div style="width:80px;height:80px;display:flex;align-items:center;justify-content:center;color:#ccc;font-size:12px;">No Image</div>';
        html += '</div>';
        html += '<a class="hdt-full-width-link" aria-label="link" href="' + product.url + '"></a>';
        html += '</div>';
      }
      
      console.log('Processing product data:', {
        title: product.title,
        price: product.price,
        priceMin: product.price_min,
        priceMax: product.price_max,
        originalImage: product.image,
        featuredImage: product.featured_image,
        finalImageUrl: imageUrl
      });
      
      // Product info (matching pr_loop_item structure) - Ensure proper column layout
      html += '<div class="hdt-card-product__info" style="flex: 1; min-width: 0;">';
      
      // Handle product title - ensure it's properly escaped and displayed
      const productTitle = product.title || '';
      html += '<a href="' + product.url + '" class="hdt-card-product__title hdt-text-base hdt-line-clamp hdt-loop-title" data-instant style="display: block; margin-bottom: 8px; color: inherit; text-decoration: none;">' + productTitle + '</a>';
      
      // Handle JSON response price structure - check multiple price fields
      let productPrice = '';
      if (product.price) {
        productPrice = product.price;
      } else if (product.price_min) {
        productPrice = product.price_min;
      } else if (product.price_max) {
        productPrice = product.price_max;
      }
      
      if (productPrice) {
        // Format price properly - Shopify prices are usually in cents
        let formattedPrice = '';
        if (typeof productPrice === 'number') {
          formattedPrice = (productPrice / 100).toFixed(2) + ' ₪';
        } else if (typeof productPrice === 'string') {
          // If it's already formatted, use as is
          formattedPrice = productPrice.includes('₪') ? productPrice : productPrice + ' ₪';
        }
        
        html += '<div class="hdt-price-wrapp hdt-text-base hdt-font-medium" style="margin-top: 4px;">';
        html += '<div class="hdt-price__list">';
        html += '<hdt-price class="hdt-price">';
        html += '<span class="hdt-money" style="color: inherit; font-weight: 500;">' + formattedPrice + '</span>';
        html += '</hdt-price>';
        html += '</div>';
        html += '</div>';
      } else {
        // If no price available, add placeholder or leave empty for cleaner look
        console.log('No price found for product:', product.title);
        console.log('Available price fields:', {
          price: product.price,
          price_min: product.price_min,
          price_max: product.price_max,
          variants: product.variants ? product.variants.map(v => ({price: v.price, title: v.title})) : 'none'
        });
      }
      
      html += '</div>'; // info
      html += '</div>'; // wrapper
      html += '</div>'; // card-product
    });
    
    html += '</div>'; // search-results-list
    html += '</div>'; // search-products
    
    return html;
  }

  // Helper function to format Shopify prices properly
  formatShopifyPrice(product) {
    let price = null;
    
    // Try different price fields in order of preference
    if (product.price_min !== undefined && product.price_min !== null) {
      price = product.price_min;
    } else if (product.price !== undefined && product.price !== null) {
      price = product.price;
    } else if (product.variants && product.variants.length > 0 && product.variants[0].price) {
      price = product.variants[0].price;
    }
    
    if (price !== null) {
      return this.formatPriceValue(price);
    }
    
    return null;
  }
  
  // Helper function to format price values consistently
  formatPriceValue(price) {
    if (typeof price === 'number') {
      // Shopify prices are in cents, convert to currency
      return (price / 100).toFixed(2) + ' ₪';
    } else if (typeof price === 'string') {
      // If it's already a string, check if it needs currency symbol
      if (price.includes('₪')) {
        return price;
      } else {
        // Try to parse as number and format
        const numPrice = parseFloat(price);
        if (!isNaN(numPrice)) {
          return (numPrice / 100).toFixed(2) + ' ₪';
        } else {
          return price + ' ₪';
        }
      }
    }
    
    return null;
  }

  formatPrice(price) {
    if (typeof price === 'number') {
      return '₪' + (price / 100).toFixed(2);
    } else if (typeof price === 'string') {
      return price;
    }
    return '';
  }

  renderNoResults(searchTerm) {
    const noResultsHTML = this.getNoResultsHTML(searchTerm);
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.cachedResults[queryKey] = noResultsHTML;
    this.renderSearchResults(noResultsHTML);
    this.setAttribute('results', true);
  }

  getSearchKey(searchTerm) {
    return searchTerm.replace(' ', '-').toLowerCase();
  }

  renderHebrewNoResults(searchTerm) {
    // Keep this method for backward compatibility but use the generic one
    this.renderNoResults(searchTerm);
  }

  getNoResultsHTML(searchTerm) {
    // Check if search term contains Hebrew or other RTL characters
    const hasRTL = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(searchTerm);
    
    if (hasRTL) {
      // Hebrew no results message
      return `
        <div class="predictive-search__results-groups-wrapper">
          <div class="predictive-search__loading-state">
            <p>לא נמצאו תוצאות עבור "${searchTerm}"</p>
            <p>נסו לחפש במילים אחרות או בדקו את הכתיב</p>
          </div>
        </div>
      `;
    } else {
      // English no results message
      return `
        <div class="predictive-search__results-groups-wrapper">
          <div class="predictive-search__loading-state">
            <p>No results found for "${searchTerm}"</p>
            <p>Try searching with different terms or check your spelling</p>
          </div>
        </div>
      `;
    }
  }

  async convertToPredictiveFormat(productElements, searchTerm) {
    if (productElements.length === 0) {
      return this.getNoResultsHTML(searchTerm);
    }

    const products = Array.from(productElements).slice(0, 8); // Show more products for Hebrew search
    
    // Determine if we're in Hebrew context for proper labels
    const isHebrew = /[\u0590-\u05FF]/.test(searchTerm);
    const productsLabel = isHebrew ? 'מוצרים' : 'Products';
    const viewAllLabel = isHebrew ? 'צפייה בכל התוצאות' : 'View all results';
    
    let htmlParts = [`<div class="hdt-search-products">
      <h6 class="hdt-search-top-title hdt-font-medium">${productsLabel}</h6>
      <div class="hdt-search-results-list hdt-row-products hdt-show-pr-price-true hdt-current-scrollbar">`];
    
    products.forEach(product => {
      try {
        // Extract product data with multiple fallbacks
        const productId = product.getAttribute('data-product-id') || 
                         product.querySelector('[data-product-id]')?.getAttribute('data-product-id') || '';
        
        const productLink = product.querySelector('a[href*="/products/"]') || 
                           product.closest('a[href*="/products/"]');
        
        // Get product image with fallbacks
        let productImage = product.querySelector('img');
        if (!productImage && productLink) {
          productImage = productLink.querySelector('img');
        }
        
        // Get product title with multiple selectors
        const titleSelectors = [
          '.hdt-pr-title-link', '.hdt-pr-title', '.product-title', 
          '.card__heading', '.card-title', 'h3 a', 'h2 a', '.product-link'
        ];
        
        let productTitle = null;
        for (const selector of titleSelectors) {
          productTitle = product.querySelector(selector);
          if (productTitle && productTitle.textContent.trim()) break;
        }
        
        // Fallback to link text if no title found
        if (!productTitle && productLink) {
          productTitle = { textContent: productLink.textContent.trim() || 'Product' };
        }
        
        // Get product price with fallbacks
        const priceSelectors = [
          '.hdt-pr-price', '.price', '.product-price', 
          '.money', '.price__container', '.card__price'
        ];
        
        let productPrice = null;
        for (const selector of priceSelectors) {
          productPrice = product.querySelector(selector);
          if (productPrice) break;
        }
        
        if (productLink && productTitle && productTitle.textContent.trim()) {
          // Get image URL and optimize for predictive search
          let imageHtml = '';
          if (productImage && productImage.src) {
            let imageSrc = productImage.src;
            // Optimize image size for predictive search
            if (imageSrc.includes('shopify') && imageSrc.includes('.jpg')) {
              imageSrc = imageSrc.replace(/(\.(jpg|jpeg|png|webp))/i, '_68x$1');
            }
            imageHtml = `<img src="${imageSrc}" alt="${productImage.alt || productTitle.textContent.trim()}" sizes="68px" loading="lazy">`;
          }
          
          htmlParts.push(`
            <div class="hdt-pr-item-wrap hdt-pr-item-wrap--predictive">
              <div class="hdt-pr-item" data-product-id="${productId}">
                <div class="hdt-pr-media">
                  <a href="${productLink.href}" class="hdt-pr-media-link">
                    ${imageHtml}
                  </a>
                </div>
                <div class="hdt-pr-summary">
                  <div class="hdt-pr-title">
                    <a href="${productLink.href}" class="hdt-pr-title-link">
                      ${productTitle.textContent.trim()}
                    </a>
                  </div>
                  ${productPrice ? `<div class="hdt-pr-price">${productPrice.innerHTML}</div>` : ''}
                </div>
              </div>
            </div>
          `);
        }
      } catch (error) {
        console.log('Error processing product:', error);
      }
    });
    
    htmlParts.push(`</div></div>`);
    
    // Add "View All" link with proper styling
    htmlParts.push(`
      <div class="hdt-search-view-all" style="padding: 15px; text-align: center; border-top: 1px solid rgb(var(--color-border)); background: rgb(var(--color-background));">
        <a href="${themeHDN.routes.search_url}?q=${encodeURIComponent(searchTerm)}" 
           class="hdt-search-view-all-link"
           style="display: inline-block; padding: 10px 20px; background: rgb(var(--color-button)); color: rgb(var(--color-button-text)); text-decoration: none; border-radius: 4px; font-weight: 500; transition: all 0.2s ease;">
          ${viewAllLabel} (${products.length}${products.length >= 8 ? '+' : ''})
        </a>
      </div>
    `);
    
    return htmlParts.join('');
  }

  getNoResultsHTML(searchTerm) {
    return `
      <div class="hdt-search-empty hdt-text-center hdt-flex hdt-align-center hdt-justify-center hdt-flex-col">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
          <path d="M32.9436 65.8872C14.7784 65.8872 0 51.1088 0 32.9436C0 14.7784 14.7784 0 32.9436 0C51.1088 0 65.8872 14.7784 65.8872 32.9436C65.8872 51.1088 51.1088 65.8872 32.9436 65.8872ZM32.9436 6.24523C18.222 6.24523 6.24523 18.222 6.24523 32.9436C6.24523 47.6652 18.222 59.642 32.9436 59.642C47.6652 59.642 59.642 47.6652 59.642 32.9436C59.642 18.222 47.6652 6.24523 32.9436 6.24523ZM79.0245 79.0855C80.2439 77.866 80.2439 75.8888 79.0245 74.6694L65.0508 60.6957C63.8313 59.4761 61.854 59.4761 60.6346 60.6957C59.4153 61.9152 59.4153 63.8925 60.6346 65.1118L74.6083 79.0855C75.218 79.6952 76.0173 80 76.8165 80C77.6157 80 78.4146 79.6952 79.0245 79.0855Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M40.6947 26.2928C40.8822 26.4803 40.9875 26.7346 40.9875 26.9998C40.9875 27.2649 40.8822 27.5193 40.6947 27.7068L35.4017 32.9998L40.6947 38.2928C40.8769 38.4814 40.9777 38.734 40.9754 38.9962C40.9731 39.2584 40.8679 39.5092 40.6825 39.6946C40.4971 39.88 40.2463 39.9852 39.9841 39.9875C39.7219 39.9897 39.4693 39.8889 39.2807 39.7068L33.9877 34.4138L28.6947 39.7068C28.5061 39.8889 28.2535 39.9897 27.9913 39.9875C27.7291 39.9852 27.4783 39.88 27.2929 39.6946C27.1075 39.5092 27.0023 39.2584 27 38.9962C26.9978 38.734 27.0986 38.4814 27.2807 38.2928L32.5737 32.9998L27.2807 27.7068C27.0986 27.5182 26.9978 27.2656 27 27.0034C27.0023 26.7412 27.1075 26.4904 27.2929 26.305C27.4783 26.1196 27.7291 26.0144 27.9913 26.0121C28.2535 26.0098 28.5061 26.1106 28.6947 26.2928L33.9877 31.5858L39.2807 26.2928C39.4682 26.1053 39.7225 26 39.9877 26C40.2529 26 40.5072 26.1053 40.6947 26.2928Z" fill="currentColor"/>
        </svg>
        <div class="hdt-no-result-product hdt-text-base hdt-font-normal">לא נמצאו תוצאות עבור "${searchTerm}"</div>
      </div>
    `;
  }

  renderHebrewNoResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    const noResultsHTML = this.getNoResultsHTML(searchTerm);
    
    this.cachedResults[queryKey] = noResultsHTML;
    this.renderSearchResults(noResultsHTML);
  }



  setLiveRegionLoadingState() {
    this.hideWrapper.style.cssText = "display: none;";
    this.showWrapper.style.cssText = "display: block;";
    this.skeleton.classList.remove("hdt-hidden");

    this.setAttribute('loading', true);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.openSearch();
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
  }

  openSearch() {
    //this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.skeleton.classList.add("hdt-hidden");
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.hideWrapper.style.cssText = "display: block;";
      this.showWrapper.style.cssText = "display: none;";
      this.predictiveSearchResults.innerHTML = "";
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    //this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('hdt-predictive-search', PredictiveSearch);

// --------------------------
// Delivery Time
// --------------------------
// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "@theme/dayjs";
dayjs.locale('en'); // use locale globally
class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    this.offDays          = this.config.off_day.replace(/ /g,'').split(",");
    this.nowDay           = dayjs();
    var format_day       = this.config.format_day,
        time             = this.config.time.replace("24:00:00", "23:59:59"),
        arrDayWeek       = ["SUN","MON","TUE","WED","THU","FRI","SAT"],
        dateStart        = this.config.estimateStartDate || 0,
        dateEnd          = this.config.estimateEndDate || 0,
        excludeDays      = this.config.cut_day.replace(/ /g,'').split(","),
        startDay         = dayjs(),
        i                = 0,
        endDay           = dayjs(),
        j                = 0,
        nowTime          = this.nowDay.format('HHmmss'),
        timeint          = time.replace(/ /g,'').replace(/:/g,''),

        arrDay           = themeHDN.extras.order.dayNames.replace(/ /g,'').split(","),
        arrMth           = themeHDN.extras.order.monthNames.replace(/ /g,'').split(",");
    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay   = this.nowDay.add(1, 'day');
      startDay = startDay.add(1, 'day');
      endDay   = endDay.add(1, 'day');
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if ( this.config.mode == '2' ) {

      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
          j--;
        }
      }

    }
    else {

      // START DATE
      startDay = startDay.add(dateStart, 'day');
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }

      // END DATE
      endDay = endDay.add(dateEnd, 'day');
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');

    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */
    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format('D')),
    daystStart       = startDayDInt + this.nth(startDayDInt),
    MntStart         = arrMth[ parseInt(startDay.format('M')) -1 ],
    dayStart         = arrDay[ parseInt(startDay.format('d')) ],

    EndDayDInt       = parseInt(endDay.format('D')),
    daystEnd         = EndDayDInt + this.nth( EndDayDInt ),
    MntEnd           = arrMth[ parseInt(endDay.format('M')) -1 ],
    dayEnd           = arrDay[ parseInt(endDay.format('d')) ];

    //console.log( startDayDInt, EndDayDInt )
    if($4('[data-start-delivery]', this)) $4('[data-start-delivery]', this).innerHTML = startDay.format(format_day).replace('t44',dayStart).replace('t45',daystStart).replace('t46',MntStart);
    if($4('[data-end-delivery]', this)) $4('[data-end-delivery]', this).innerHTML = endDay.format(format_day).replace('t44',dayEnd).replace('t45',daystEnd).replace('t46',MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter( onlyUnique );
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = "";
        if( variant.variant_state.pre_order ) {
          this.closest(".hdt-product-info__item").style.display = "none"
        }
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('order-delivery', orderDelivery);
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute('config'));
    const time = this.config.time.replace("24:00:00", "23:59:59")

    if (time == '19041994') return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay  = !this.textTemp.includes('[days]');
    let today        = dayjs();

    const nowTime      = today.format('HHmmss'),
          configTime   = time.replace(/ /g,'').replace(/:/g,'')

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, 'day');
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(`${today.format('YYYY-MM-DD')} ${time}`).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval( this.#update.bind(this), this.textTemp.includes('[secs]') ? 1000 : 60000);
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
    let   hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days*24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp.replace('[days]', String(days).padStart(2, '0')).replace('[hours]', String(hours).padStart(2, '0')).replace('[mins]', String(minutes).padStart(2, '0')).replace('[secs]', String(seconds).padStart(2, '0'));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define('hdt-countdown-simple', countdownSimple);


// Begin instagram feed api
const dataInstagramCache = {};
class instagramFeedAPI extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        this.refresh_ins();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const {acc,id} = this.config;
        var data = sessionStorage.getItem('hdt_ins'+acc+id);
        if (data != null && data != '') {
          sessionStorage.removeItem('hdt_ins'+acc+id);
        }
      })
    }
  }
  connectedCallback() {
    this.refresh_ins();
  }
  refresh_ins(){
    const {acc,id} = this.config;

    if (acc == '') return;

    var data = sessionStorage.getItem('hdt_ins'+acc+id);

    if (data != null && data != '') {
      // calculate expiration time for content,
      // to force periodic refresh after 30 minutes
      var now = new Date(),
      expiration = new Date(JSON.parse(data).timestamp);

      expiration.setMinutes(expiration.getMinutes() + 30);

      // ditch the content if too old
      if (now.getTime() > expiration.getTime()) {
        data = null;
        sessionStorage.removeItem('hdt_ins'+acc+id);
      }
    }
    if ( data != null && data != '' ) {
      this.instagramHTML(JSON.parse(data).content,false);
    }
    else{
      if (dataInstagramCache[acc]) {
        $4('.hdt-slider__container', this).innerHTML = dataInstagramCache[acc];
        $4('.hdt-ins-loading', this)?.remove();
        const lazySlider = $4('hdt-slider-lazy', this);
        if (lazySlider) {
          lazySlider.hidden = false;
          lazySlider.InitLazy();
        }
        return;
      }

      fetch('https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token='+atob(acc))
      .then((response) => {
        if(!response.ok) {
          throw new Error("not ok"); 
        }
        return response.json()
      })
      //.then(function(res)
      .then((res) => {
        //console.log('Success:', res);
         this.instagramHTML(res.data,true);
      })
      .catch((err) => {
        $4('.hdt-ins-loading', this)?.remove();
        console.error("Instagram Feed:error fetch");
        console.error(err);
      });
    }
  }
  instagramHTML(data,saveSessionStorageIns) {
    const arrIcons = ($4('.hdt-icons-ins-svg', this).innerHTML || '').split('[hdtplit]'),
    icons = {
       image : arrIcons[0],
       video : arrIcons[1],
       carousel_album: arrIcons[2]
    },
    {id, acc, target, limit} = this.config;
    let html = '';

    data.forEach( (el, index) => {
      if (index >= limit) return 0;
      const media_type = el.media_type.toLowerCase();
      html += `<div class="hdt-slider__slide hdt-ins-type-${media_type}"><a calc-nav data-no-instant rel="nofollow" class="hdt-ins-inner hdt-block hdt-relative hdt-oh hdt-radius" href="${el.permalink}" target="${target}"><div class="hdt-ratio"><img src="${el.thumbnail_url || el.media_url}" class="hdt-ins-img" loading="lazy"></div><div class="hdt-ins-icon">${icons[media_type]}</div></a></div>`
    });
    dataInstagramCache[acc] = html;
    $4('.hdt-slider__container', this).innerHTML = html;
    $4('.hdt-ins-loading', this)?.remove();
    const lazySlider = $4('hdt-slider-lazy', this);
    if (lazySlider) {
      lazySlider.hidden = false;
      lazySlider.InitLazy();
    }

    if(saveSessionStorageIns){
      sessionStorage.setItem('hdt_ins'+acc+id, JSON.stringify({
        timestamp: new Date(),
        content: data
      }));
    }
  }
}
customElements.define('ins-feed-api', instagramFeedAPI);


// product description - readmore
class ProductDescription extends HTMLElement{
  constructor(){
    super();
    this.lm_btn = this.querySelector('.hdt-pr-des-rm');
    if(!this.lm_btn) return;
    
    this.lm_btn.addEventListener('click',()=>{
      this.classList.toggle('is--less');
    })
  }
}
customElements.define('product-description',ProductDescription);



// check purchase code
if(Shopify.designMode){

  /**
  * If it's a global variable then window[variableName] or in your case window["onlyVideo"] should do the trick.
  * https://stackoverflow.com/questions/5613834/convert-string-to-variable-name-in-javascript
  */
  function isStorageSupported(type) {
    // Return false if we are in an iframe without access to sessionStorage
    // window.self !== window.top

    var storage = (type === 'session') ? window.sessionStorage : window.localStorage;

    try {
      storage.setItem('t4s', 'test');
      storage.removeItem('t4s');
      return true;
    } catch (error) {
      return false;
    }
  };

  var ThemeCode    = atob(window[atob('Y0hWeVkyaGg=')]),
      ThemeName_base64 = window[atob('VkdobGJXVk9ZVzFsVkRR')],
      ThemeName            = atob(ThemeName_base64),
      CookieName           = 'SXNBY3RpdmVUaGVtZQ=='+ThemeName_base64,
      ShopEmail            = atob(window[atob('VTJodmNFMWxiMVEw')]),
      isTrueSet            = (sessionStorage.getItem(CookieName) === 'true' ),
      str_temp_active      = atob('I3Q0cy10ZW1wLWtleS1hY3RpdmU='), // #t4s-temp-key-active
      str_purchase         = atob('cHVyY2hhc2VfY29kZXQ0'); // purchase_codet4;

      // console.log(ThemeCode,ThemeName,ShopEmail,CookieName,str_temp_active,str_purchase)
  function alert_active_html() {
    return `<section id="${str_purchase}" style="display: flex !important">${ $4(str_temp_active).innerHTML }</section>`;
  };

  // console.log('ThemeCode', ThemeCode, isTrueSet)

  if (ThemeCode == '') {
    let dom1 = (new DOMParser).parseFromString(alert_active_html(), "text/html");
    document.body.append(dom1.body.firstElementChild);
    let dom2 = (new DOMParser).parseFromString('<div id="luffyabc194"><style>body>*:not(#purchase_codet4) {opacity: 0;pointer-events: none;</style></div>', "text/html");
    document.body.prepend(dom2.body.firstElementChild);
    sessionStorage.removeItem(CookieName);
    localStorage.removeItem(CookieName);
  }
  else if ( !isTrueSet ) {

    //console.log(ShopEmail, ThemeName, ThemeCode);

    var domain     = window.location.hostname,
    mix        = ['4','t','h','e','p','l','i','c','o','/','.',':','n','s'],
    mix_domain = mix[2]+mix[1]+mix[1]+mix[4]+mix[13]+mix[11]+mix[9]+mix[9]+mix[5]+mix[6]+mix[7]+mix[10]+mix[1]+mix[2]+mix[3]+mix[0]+mix[10]+mix[7]+mix[8]+mix[9]+mix[5]+mix[6]+mix[7]+mix[3]+mix[12]+mix[13]+mix[3]+mix[9]+mix[7]+mix[2]+mix[3]+mix[7]+'k',
    data       = {
      "shopify_domain": domain,
      "email"         : ShopEmail,
      "theme"         : ThemeName,
      "purchase_code" : ThemeCode
    };

    fetch(mix_domain, {
      "headers": {
        "accept": "*/*",
        "cache-control": "no-cache",
        "x-requested-with": "XMLHttpRequest"
      },
      "body": btoa (encodeURIComponent(JSON.stringify(data))) ,
      "method": "POST",
      "mode": "cors"
    })
    .then(function(response) {
      if(response.ok){
        return response.json()
      } throw ""
    })
    .then(function(response) {
      let dom = (new DOMParser).parseFromString(alert_active_html(), "text/html");

      if ( response.status == 1) {

        dom.body.firstElementChild.innerHTML = "<p>ACTIVATED SUCCESSFULLY. Thanks for buying my theme!</p>";
        document.body.append(dom.body.firstElementChild);

        // Set a cookie to expire in 1 hour in Javascript
        var isActived = localStorage.getItem(CookieName);
        sessionStorage.setItem(CookieName, 'true')

        if (isActived === 'true') {
          $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
          // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
        }
        else {
          localStorage.setItem(CookieName, "true");
          setTimeout(function(){
            $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
            // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
          }, 1000);
        }

      }
      else {

        var mess = response.message;
        if (mess == "No sale belonging to the current user found with that code") {

          dom.body.firstElementChild.innerHTML = "<p>Purchase code error. It is a sales reversal or a refund. :(((</p>";

        }
        else if (mess.length == 58 || mess.length == 101) {
          dom.body.firstElementChild.innerHTML = "<p>That license key doesn't appear to be valid. Please check your purchase code again!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";

        }
        else if (mess.length == 104) {
          dom.body.firstElementChild.innerHTML = "<p>The license not match with current theme.!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
        }
        else {
          try {
            var mess = mess.split('active domain `')[1].split('`. ')[0];
          }
          catch(err) {
            //var mess = mess;
          }
          dom.body.firstElementChild.innerHTML = "<p>Your purchase code is invalided since it is being activated at another store "+mess+".<br> Please open a ticket at <a class='cg' href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> to get quick assistance.</p>";
        }
        document.body.append(dom.body.firstElementChild);

      }

    }).catch(function(e) {
    //}).catch((e)=>{
      console.error(e)
    });

  }
}
// end check purchase code

// Masonry layout + filter sorting
// Masonry Layout Component
class MasonryLayout extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.style.position = 'relative';
    // Đọc config từ thuộc tính nếu có
    const configAttr = this.getAttribute('config');
    if (configAttr) {
      try {
        const userConfig = JSON.parse(configAttr);
        this.config = { ...userConfig };
      } catch (e) {
        this.config = {
          col_dk: 5,
          col_tb: 4,
          col_mb: 2,
          gap: 30,
          selector: '.hdt-masonry-item'
        };
      }
    }
    // console.log(this.config)
    this.waitForImages().then(() => {
      this.layoutMasonry();
      this.animateItems();
      // Set transition cho resize sau khi animation ban đầu hoàn thành
      setTimeout(() => {
        items.forEach(item => {
          item.style.transition = 'left 0.3s ease, top 0.3s ease, width 0.3s ease';
        });
      }, items.length * 100 + 500); // Đợi tất cả animation ban đầu hoàn thành
    });
    window.addEventListener('resize', () => {
      this.layoutMasonry();
      // this.animateItems();
    });
  }


  waitForImages() {
    const images = Array.from(this.querySelectorAll('img'));
    // console.log(images)
    if (images.length === 0) return Promise.resolve();
    let loaded = 0;
    return new Promise(resolve => {
      images.forEach(img => {
        const item = img.closest(this.config.selector);
        function hideLoading() {
          const loading = item?.querySelector('.item-loading');
          if (loading) loading.style.display = 'none';
          img.style.display = 'block';
        }
        if (img.complete) {
          hideLoading();
          loaded++;
          if (loaded === images.length) resolve();
        } else {
          // console.log(img)
          img.style.display = 'none';
          img.addEventListener('load', () => {
            hideLoading();
            loaded++;
            if (loaded === images.length) resolve();
          }, { once: true });
          img.addEventListener('error', () => {
            hideLoading();
            loaded++;
            if (loaded === images.length) resolve();
          }, { once: true });
        }
      });
    });
  }

  layoutMasonry() {
    const items = Array.from(this.querySelectorAll(this.config.selector)).filter(item => item.style.display !== 'none');
    // console.log(items)
    const containerWidth = this.clientWidth;
    let columnCount = this.config.col_dk;
    let gap = this.config.gap;
    if (containerWidth < 768) columnCount = this.config.col_mb, gap = this.config.gap_mb;
    else if (containerWidth < 1149) columnCount = this.config.col_tb;

    const columnHeights = Array(columnCount).fill(0);
    const columnWidth = (containerWidth - gap * (columnCount - 1)) / columnCount;
    // Bước 1: set width cho tất cả item
    items.forEach(item => {
      item.style.display = 'block';
      item.style.position = 'absolute';
      item.style.width = `${columnWidth}px`;
    });
    // Bước 2: ép reflow
    items.forEach(item => void item.offsetHeight);
    // Bước 3: tính toán vị trí
    items.forEach(item => {
      const minCol = columnHeights.indexOf(Math.min(...columnHeights));
      const x = minCol * (columnWidth + gap);
      const y = columnHeights[minCol];
      item.style.left = `${x}px`;
      item.style.top = `${y}px`;
      columnHeights[minCol] += item.offsetHeight + gap;
    });
    this.style.height = Math.max(...columnHeights) + 'px';
  }

  animateItems() {
    const items = Array.from(this.querySelectorAll(this.config.selector));
    items.forEach((item, index) => {
      setTimeout(() => {
        item.style.visibility = 'visible';
        item.style.opacity = '0';
        item.style.transform = 'translateY(30px)';
        item.style.transition = 'opacity 0.5s, transform 0.5s';
        setTimeout(() => {
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }, 10);
      }, index * 100);
    });
  }
}

// Filter Sorting Component
class FilterSorting extends HTMLElement {
  constructor() {
    super();
    this.selector = this.getAttribute('config') ? JSON.parse(this.getAttribute('config')).selector : '.hdt-masonry-item';
  }

  connectedCallback() {
    // Không render vào shadowRoot nữa, chỉ cần giữ nguyên DOM
    this.initializeFilter();
  }

  initializeFilter() {
    // Lấy các filter-item trong DOM thường
    const filterItems = this.querySelectorAll('[data-category]');
    // Lấy masonry-layout bên trong
    const masonry = this.querySelector('hdt-masonry-layout');
    if (!masonry) return;
    const items = masonry.querySelectorAll(this.selector);
    // console.log(items)

    filterItems.forEach(filter => {
      filter.addEventListener('click', () => {
        // Remove active class from all filters
        filterItems.forEach(f => f.classList.remove('hdt-active'));
        // Add active class to clicked filter
        filter.classList.add('hdt-active');

        const category = filter.getAttribute('data-category');
        items.forEach(item => {
          if (category === 'all' || item.classList.contains(category)) {
            item.style.display = 'block';
            setTimeout(() => {
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            }, 100);
          } else {
            item.style.opacity = '0';
            item.style.transform = 'translateY(20px)';
            setTimeout(() => {
              item.style.display = 'none';
            }, 300);
          }
        });
        // Gọi lại layoutMasonry sau khi filter
        setTimeout(() => {
          if (typeof masonry.layoutMasonry === 'function') {
            masonry.layoutMasonry();
          }
        }, 350); // Đợi animation ẩn/hiện xong
      });
    });
  }
}

document.querySelectorAll('[data-newsletter-btn]').forEach(button => {
  // Find parent form
  const form = button.closest('form');
  if (!form) return;

  // Find all checkboxes in the form
  const checkboxes = form.querySelectorAll('input[type="checkbox"]');

  // Function to check all checkboxes
  const checkAllChecked = () => {
    const allChecked = Array.from(checkboxes).every(chk => chk.checked);
    button.style.opacity = allChecked ? "1" : "0.5"; // Enable if all checked
  };

  // Listen for changes on each checkbox
  checkboxes.forEach(chk => {
    chk.addEventListener('change', checkAllChecked);
  });

  // Run on page load in case some checkboxes are pre-checked
  checkAllChecked();
});

// Đăng ký custom elements
customElements.define('hdt-masonry-layout', MasonryLayout);
customElements.define('hdt-filter-sorting', FilterSorting);

// Hebrew form validation messages with custom tooltip
document.addEventListener('DOMContentLoaded', function() {
  // Hebrew validation messages
  const hebrewMessages = {
    valueMissing: 'אנא מלא שדה זה.',
    typeMismatch: {
      email: 'אנא הזן כתובת אימייל תקינה.',
      tel: 'אנא הזן מספר טלפון תקין.',
      url: 'אנא הזן כתובת URL תקינה.'
    },
    patternMismatch: 'אנא התאם לפורמט הנדרש.',
    tooLong: 'הטקסט ארוך מדי.',
    tooShort: 'הטקסט קצר מדי.',
    rangeOverflow: 'הערך גדול מדי.',
    rangeUnderflow: 'הערך קטן מדי.',
    stepMismatch: 'הערך אינו תקין.'
  };

  // Function to get validation message
  function getValidationMessage(input) {
    const validity = input.validity;

    if (validity.valueMissing) {
      return hebrewMessages.valueMissing;
    } else if (validity.typeMismatch) {
      const inputType = input.type;
      return hebrewMessages.typeMismatch[inputType] || hebrewMessages.typeMismatch.email;
    } else if (validity.patternMismatch) {
      return hebrewMessages.patternMismatch;
    } else if (validity.tooLong) {
      return hebrewMessages.tooLong;
    } else if (validity.tooShort) {
      return hebrewMessages.tooShort;
    } else if (validity.rangeOverflow) {
      return hebrewMessages.rangeOverflow;
    } else if (validity.rangeUnderflow) {
      return hebrewMessages.rangeUnderflow;
    } else if (validity.stepMismatch) {
      return hebrewMessages.stepMismatch;
    }
    return '';
  }

  // Function to create custom tooltip
  function createCustomTooltip(input, message) {
    // Remove existing tooltip
    const existingTooltip = input.parentElement.querySelector('.custom-validation-message');
    if (existingTooltip) {
      existingTooltip.remove();
    }

    // Create new tooltip
    const tooltip = document.createElement('div');
    tooltip.className = 'custom-validation-message';
    tooltip.textContent = message;
    tooltip.style.display = 'block';

    // Insert tooltip after the input
    input.parentElement.appendChild(tooltip);

    // Auto hide after 5 seconds
    setTimeout(() => {
      if (tooltip.parentElement) {
        tooltip.remove();
      }
    }, 5000);

    return tooltip;
  }

  // Function to remove custom tooltip
  function removeCustomTooltip(input) {
    const tooltip = input.parentElement.querySelector('.custom-validation-message');
    if (tooltip) {
      tooltip.remove();
    }
  }

  // Function to set custom validation message
  function setCustomMessage(input) {
    const message = getValidationMessage(input);
    input.setCustomValidity(message);

    // Create custom tooltip for better appearance
    if (message && input.closest('.hdt-contact-form')) {
      createCustomTooltip(input, message);
    }
  }

  // Apply to all form inputs with validation
  const inputs = document.querySelectorAll('input[required], textarea[required], select[required]');

  inputs.forEach(function(input) {
    // Set custom message on invalid event
    input.addEventListener('invalid', function(e) {
      setCustomMessage(this);

      // Prevent default browser tooltip for contact forms
      if (this.closest('.hdt-contact-form')) {
        e.preventDefault();
      }
    });

    // Clear custom message when input becomes valid
    input.addEventListener('input', function() {
      if (this.validity.valid) {
        this.setCustomValidity('');
        removeCustomTooltip(this);
      } else {
        const message = getValidationMessage(this);
        this.setCustomValidity(message);
      }
    });

    // Handle focus events
    input.addEventListener('focus', function() {
      removeCustomTooltip(this);
    });

    // Also handle blur event
    input.addEventListener('blur', function() {
      if (!this.validity.valid) {
        setCustomMessage(this);
      }
    });
  });

  // Handle form submission to show custom tooltips
  document.addEventListener('submit', function(e) {
    const form = e.target;
    const invalidInputs = form.querySelectorAll(':invalid');

    if (invalidInputs.length > 0 && form.closest('.hdt-contact-form')) {
      e.preventDefault();

      // Show custom tooltips for all invalid inputs
      invalidInputs.forEach(function(input) {
        const message = getValidationMessage(input);
        if (message) {
          createCustomTooltip(input, message);
          input.setCustomValidity(message);
        }
      });

      // Focus first invalid input
      invalidInputs[0].focus();
    }
  });
});